import { Checkbox, DataSource, ExcludableTextbox, Layout, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutDriverHistoryReport extends Layout {
    checkboxPageBreak: Checkbox;
    excludabletextboxD: ExcludableTextbox;
    excludabletextboxDriverManager: ExcludableTextbox;
    sourceDriverHistory: DataSource;
    switchShowNote: Switch;
    textboxDateRange: Textbox;
    textboxDateType: Textbox;
    textboxDriverStatus: Textbox;
    textboxDriverType: Textbox;
    textboxGroupBy: Textbox;
}
